import { type Repub, type RepubConfig, REPUBS } from '~/vendor/cx-modules/constants';

export function getRepubConfigByName(repub: Repub): RepubConfig {
  return REPUBS[repub] ?? REPUBS.OC;
}
